// extracted by mini-css-extract-plugin
export default {"modalBody":"styles_modalBody__96Kmc"};